import { render, staticRenderFns } from "./PetsInstitucional.vue?vue&type=template&id=442a2518&"
import script from "./PetsInstitucional.vue?vue&type=script&lang=js&"
export * from "./PetsInstitucional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports